import React, { Component } from 'react'
import { Link } from 'gatsby'
//import { window, document } from "browser-monads"
import { Row, Col, Container, Button } from "react-bootstrap"

/**
* Search component.
*
* - Uses Flexsearch (https://github.com/nextapps-de/flexsearch)
* - Config found within gatsby-config, see https://github.com/nextapps-de/flexsearch#best-practices for config options
*/
class Search extends Component {
  state = {
    query: '',
    results: [],
  }

  render() {
    const ResultList = () => {

      if(this.state.query.length < 3) {
        return <span className="search__label">Please insert at least 3 characters</span>
      }
      else {
        if (this.state.results.length > 0) {

          let returnSearch = []
          let resultType = ""
          this.state.results.map((page, i) => {

            // Assign a type to the results to give context based on URL path.
            if(page.url.indexOf("/our-thinking/") !== -1) {
              resultType = " (found in: Our insights)"
            }
            else if(page.url.indexOf("/our-people/") !== -1) {
              resultType = " (found in: Our people)"
            }
            else if(page.url.indexOf("/offices/") !== -1) {
              resultType = " (found in: Our offices)"
            }

            returnSearch.push(
              <div className="item-search" key={i}>
                 <Link to={page.url} className="link">
                   <h4 className="h6">{page.title}<span>{resultType}</span></h4>
                 </Link>
               </div>
            )

            resultType = ""
          });

          return returnSearch

        } else {
          return 'No results for ' + this.state.query
        }
      }
    }

    function handleClose() {
      const searchTool = document.getElementById("js-site-search")
      searchTool.classList.remove("active")
    }

    return (
      <div id="js-site-search" className="site__search">
        <Button id="js-close-search" className="close-btn text-link--red" onClick={handleClose}>Close</Button>
        <Container fluid>
          <Row>
            <Col xs={12} md={12} lg={12}>
              <div className="search__tool">
                <div className="search__title">
                  <hr/>
                  <div className="h3">What can we find for you?</div>
                </div>
                <span className="search__label">Enter the terms you wish to search for</span>
                <div className="search__input">
                  <input
                    type="text"
                    id="js-site-search-input"
                    onChange={this.search}
                    placeholder={'Type here to search the site'}
                    aria-label="search"
                  />
                </div>
              </div>
              <div className="search__list">
                <ResultList />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }


  // Pull the seach results from the index
  getSearchResults(searchQuery) {
    var index = window.__FLEXSEARCH__.en.index
    var store = window.__FLEXSEARCH__.en.store
    if (!searchQuery || !index) {
      return []
    } else {
      var results = []
      Object.keys(index).forEach(idx => {
        results.push(...index[idx].values.search({
          query: searchQuery,
          limit: 5,
          suggest: false,
          page: true,
        }))
      })

      results = Array.from(new Set(results))

      var nodes = store
        .filter(node => (results.includes(node.id) ? node : null))
        .map(node => node.node)

      return nodes
    }
  }

  // Run a search on input change.
  search = event => {
    const query = event.target.value
    if (query.length > 2) {
      const results = this.getSearchResults(query)
      this.setState({ results: results, query: query })
    } else {
      this.setState({ results: [], query: query })
    }
  }
}

export default Search

